import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateAgoPipe, FilterValuePipe, ProfilePhotoPipe, LastActivePipe } from '@pipes';

@NgModule({
  declarations: [DateAgoPipe, FilterValuePipe, ProfilePhotoPipe, LastActivePipe],
  imports: [CommonModule],
  exports: [DateAgoPipe, FilterValuePipe, ProfilePhotoPipe, LastActivePipe],
})
export class PipeModule {}
